import FooterButtons from './FooterButtons';

export default FooterButtons;
